export var validateForm = function (formData, appConfig) {
    var errorMessages = '';
    if (!isValidPhoneNumber(formData.phone)) {
        errorMessages += appConfig.translations.invalidPhoneNumber;
    }
    if (!isValidZipCode(formData.zip)) {
        if (errorMessages)
            errorMessages += ' ';
        errorMessages += appConfig.translations.invalidZipCode;
    }
    return errorMessages;
};
export var isValidZipCode = function (zip) { return /^\d{5}$/.test(zip); };
export var isValidPhoneNumber = function (phone) {
    return /^(?:\+|00)([0-9]{1,3})\s?([0-9]\s?){5,14}$/.test(phone);
};
